import React from 'react';
import { StockProvider } from './context/StockContext';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { StockCounter } from './components/StockCounter';
import { LifestyleBreak } from './components/LifestyleBreak';
import { ProductGalleryMid } from './components/ProductGalleryMid';
import { ProductDetails } from './components/ProductDetails';
import { ValueStack } from './components/ValueStack';
import { ProductGalleryBottom } from './components/ProductGalleryBottom';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { LegalFooter } from './components/LegalFooter';
export function App() {
  return <StockProvider data-id="element-0">
      <div className="w-full min-h-screen bg-[#0A0A0A]" data-id="element-1">
        <UrgencyBar data-id="element-2" />
        <HeroSection data-id="element-3" />
        <StockCounter data-id="element-4" />
        <LifestyleBreak data-id="element-5" />
        <ProductGalleryMid data-id="element-6" />
        <ProductDetails data-id="element-7" />
        <ValueStack data-id="element-8" />
        <ProductGalleryBottom data-id="element-9" />
        <FAQ data-id="element-10" />
        <Footer data-id="element-11" />
        <LegalFooter data-id="element-12" />
      </div>
    </StockProvider>;
}